import React, { useState, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2, AlertTriangle } from 'lucide-react';

function GroupConfirmationPopup({
    HeadingText,
    popupName,
    closeResetPopup,
    openManageGroup,
    openEditGroup,
    SelectedGroupNumber,
    cPagin,
    cSearch,
    dIndex,
    userList
}) {
    const [loading, setLoading] = useState(false);

    const handleYes = useCallback(() => {
        setLoading(true);
        
        if (popupName === "ResetGroup") {
            closeResetPopup?.();
            openManageGroup?.(SelectedGroupNumber, '', cPagin, cSearch, 'yes');
        } else if (popupName === "DeleteReps") {
            closeResetPopup?.();
            openEditGroup?.(dIndex, popupName, 'yes', userList, '', SelectedGroupNumber);
        }
    }, [popupName, closeResetPopup, openManageGroup, openEditGroup, SelectedGroupNumber, cPagin, cSearch, dIndex, userList]);

    const handleBack = useCallback(() => {
        if (popupName === "ResetGroup") {
            closeResetPopup?.();
            openManageGroup?.(SelectedGroupNumber, '', cPagin, cSearch);
        } else if (popupName === "DeleteReps") {
            closeResetPopup?.();
            openEditGroup?.(dIndex, popupName, 'no', userList, '', SelectedGroupNumber);
        }
    }, [popupName, closeResetPopup, openManageGroup, openEditGroup, SelectedGroupNumber, cPagin, cSearch, dIndex, userList]);

    const handleOpenChange = useCallback((open) => {
        if (!open) {
            handleBack();
        }
    }, [handleBack]);

    return (
        <Dialog open={true} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    {/* Empty or minimal header to create space from close button */}
                </DialogHeader>
                
                {/* Centered icon and text with proper spacing */}
                <div className="flex flex-col items-center text-center gap-4 mt-4 px-6 py-4">
                    <AlertTriangle className="h-12 w-12 text-amber-500" />
                    <p className="text-lg font-medium text-foreground">
                        {HeadingText}
                    </p>
                </div>

                <DialogFooter>
                    <Button 
                        variant="destructive" 
                        onClick={handleYes}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                Processing...
                            </>
                        ) : (
                            'Yes'
                        )}
                    </Button>
                    <Button variant="secondary" onClick={handleBack}>
                        No
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default GroupConfirmationPopup;
